import styled from 'styled-components';

export const BannerCarouselWrapper = styled.div`
  [class*='FunctionalCarouselstyle__Carousel-sc-'] {
    margin: 0;
    .slick-slide > div {
      margin: 0;
    }
    [class*='Interactionstyle__Button-sc-'] {
      box-shadow: none !important;
    }

    [class*='FunctionalCarouselstyle__CarouselLoaderPager-sc-'] {
      padding: 20px;

      [class*='FunctionalCarouselstyle__CarouselLoaderPagerArrow-sc-'] {
        align-self: flex-end;
        padding-bottom: 2px;
        margin: 0 70px;

        & > [class*='Interactionstyle__Button-sc-'] {
          display: flex;
          align-items: center;
        }
      }

      [class*='CarouselLoaderPagerstyle__Title-sc-'] {
        min-height: unset;
        padding-bottom: 0;
      }
    }
  }
`;
